import React from "react"
import {CmCollection} from "../../../../packages/graphql-layer/src";
import C020TeaserCarousel from "../../content/C020TeaserCarousel/C020TeaserCarousel";
import {useTranslation} from "react-i18next";


export interface Props {
    relatedContents: any[]
}

function P011PublicationRelatedContent(props: Props) {
    const {t} = useTranslation();
    return <React.Fragment key='related'>
        <C020TeaserCarousel cmCollection={{items: props.relatedContents} as CmCollection}
                            headline={t('p011_related_content_title')!}/>
    </React.Fragment>

}

export default P011PublicationRelatedContent